import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import ProductTicket from "../views/product/Ticket.vue";
// import ProductBigdata from "../views/product/Bigdata.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    meta: { title: "首页" },
    component: () => import(/* webpackChunkName: "home" */ "../views/index/Index.vue")
  },
  {
    path: "/index",
    name: "Index",
    meta: { title: "首页" },
    component: () => import(/* webpackChunkName: "index" */ "../views/index/Index.vue")
  },
  {
    path: "/product",
    name: "Product",
    component: () => import(/* webpackChunkName: "product" */ "../views/product/Index.vue"),
    children: [
      {
        path: "ticket",
        name: "product-ticket",
        meta: { title: "票务系统", cnName: "票务系统" },
        component: () => import(/* webpackChunkName: "product" */ "../views/product/Ticket.vue")
      },
      {
        path: "bigdata",
        meta: { title: "大数据监控", cnName: "大数据监控" },
        component: () => import(/* webpackChunkName: "product" */ "../views/product/Bigdata.vue")
      },
      {
        path: "distribution",
        component: () =>
          import(/* webpackChunkName: "product" */ "../views/product/Distribution.vue")
      },
      {
        path: "passengerFlow",
        component: () =>
          import(/* webpackChunkName: "product" */ "../views/product/PassengerFlow.vue")
      },
      {
        path: "commService",
        meta: { title: "社会化服务", cnName: "社会化服务" },
        component: () =>
          import(/* webpackChunkName: "product" */ "../views/product/CommService.vue")
      },
      {
        path: "ops",
        meta: { title: "运维服务", cnName: "运维服务" },
        component: () => import(/* webpackChunkName: "product" */ "../views/product/Ops.vue")
      },
      {
        path: "consulting",
        meta: { title: "咨询服务", cnName: "咨询服务" },
        component: () => import(/* webpackChunkName: "product" */ "../views/product/Consulting.vue")
      },
      {
        path: "hardware",
        meta: { title: "硬件产品", cnName: "硬件产品" },
        component: () => import(/* webpackChunkName: "product" */ "../views/product/Hardware.vue")
      }
    ]
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    component: () => import(/* webpackChunkName: "aboutus" */ "../views/aboutus/Index.vue"),
    children: [
      {
        path: "profile",
        name: "aboutus-profile",
        meta: { title: "公司简介" },
        component: () => import(/* webpackChunkName: "aboutus" */ "../views/aboutus/Profile.vue")
      },
      {
        path: "qualification",
        name: "aboutus-qualification",
        meta: { title: "公司资质" },
        component: () =>
          import(/* webpackChunkName: "aboutus" */ "../views/aboutus/Qualification.vue")
      },
      {
        path: "team",
        name: "aboutus-team",
        component: () => import(/* webpackChunkName: "aboutus" */ "../views/aboutus/Team.vue")
      },
      {
        path: "recruit",
        name: "aboutus-recruit",
        meta: { title: "公司招聘" },
        component: () => import(/* webpackChunkName: "aboutus" */ "../views/aboutus/Recruit.vue")
      }
    ]
  },
  {
    path: "/news",
    name: "News",
    meta: { title: "新闻动态" },
    component: () => import(/* webpackChunkName: "news" */ "../views/news/Index.vue"),
    children: []
  },
  {
    path: "/news/detail/:news_id",
    name: "NewsDetail",
    meta: { title: "新闻动态" },
    component: () => import(/* webpackChunkName: "news" */ "../views/news/Detail.vue")
  },
  {
    path: "/home",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
  // {
  //   path: "*",
  //   name: "error_404",
  //   component: error_404
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + " - 凯泰铭科技文化";
  }

  if (to.fullPath) {
    _hmt.push(["_trackPageview", "/#" + to.fullPath]);
  }
  next();
});

export default router;
